import { DriversFilter } from '../models';
import { useGetDriversQuery } from '../services';

interface UseDriversProps {
  filters?: DriversFilter;
  paginated: {
    page: number;
    pageSize: number;
  };
}

const useDrivers = ({ filters, paginated }: UseDriversProps) => {
  const {
    data: drivers,
    isLoading,
    isFetching,
  } = useGetDriversQuery({ filters: filters || {}, paginated });

  return {
    drivers: drivers?.items || [],
    totalItems: drivers?.count || 0,
    totalPages: drivers?.count ? Math.ceil(drivers.count / paginated.pageSize) : 0,
    isDriversLoading: isLoading || isFetching,
  };
};

export default useDrivers;
